import { __extends } from "tslib";
import NodeInlineElement from './NodeInlineElement';
/**
 * This is an inline element representing an Html image
 */
var ImageInlineElement = /** @class */ (function (_super) {
    __extends(ImageInlineElement, _super);
    function ImageInlineElement(containerNode, parentBlock) {
        return _super.call(this, containerNode, parentBlock) || this;
    }
    return ImageInlineElement;
}(NodeInlineElement));
export default ImageInlineElement;
//# sourceMappingURL=ImageInlineElement.js.map